import { Box, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';

import CaloLoader from '../../../components/CaloLoader';
import { Currency } from '../../../lib/enum';
import { AffiliateCouponItem, AffiliateRes } from '../../../lib/types';
import { caloTheme } from 'src/theme/calo';
import AffiliateCouponRow from './AffiliateCouponRow';

interface AffiliateCouponsTableProps {
  coupons: AffiliateCouponItem[];
  couponsLoading: boolean;
  currency?: Currency;
  affiliateId?: string;
  affiliate?: AffiliateRes;
}

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    border: 'none'
  },
  [`&.${tableCellClasses.body}`]: {
    border: 'none',
    justifyContent: 'space-between'
  }
}));

const AffiliateCouponsTable = ({
  coupons,
  couponsLoading,
  currency,
  affiliateId,
  affiliate
}: AffiliateCouponsTableProps) => (
  <Box
    sx={{
      padding: { xs: 1, sm: 2 },
      backgroundColor: 'white',
      borderRadius: '8px',
      overflowX: 'auto',
      mt: 3
    }}
  >
    {couponsLoading ? (
      <Stack sx={{ width: '100%', justifyContent: 'center' }}>
        <CaloLoader />
      </Stack>
    ) : (
      <Table
        sx={{
          marginY: '4px',
          minWidth: { xs: '800px', md: '100%' }
        }}
      >
        <TableHead
          sx={{
            backgroundColor: caloTheme.palette.neutral50,
            borderRadius: '8px'
          }}
        >
          <TableRow>
            <StyledTableCell
              sx={{
                borderRadius: '8px 0 0 8px',
                whiteSpace: 'nowrap',
                fontSize: { xs: '12px', sm: '14px' }
              }}
            >
              Coupon Code
            </StyledTableCell>
            <StyledTableCell sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
              Total Users Invited
            </StyledTableCell>
            <StyledTableCell
              sx={{
                borderRadius: '0 8px 8px 0',
                fontSize: { xs: '12px', sm: '14px' }
              }}
            >
              Actions
            </StyledTableCell>
          </TableRow>
        </TableHead>
        {coupons?.length > 0 ? (
          <TableBody>
            {coupons.map((coupon) => (
              <AffiliateCouponRow
                coupon={coupon}
                currency={currency}
                affiliateId={affiliateId}
                affiliate={affiliate}
                key={coupon.id}
              />
            ))}
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell colSpan={3}>
                <Typography align="center" sx={{ py: 2 }}>
                  NO COUPONS!
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
    )}
  </Box>
);

export default AffiliateCouponsTable;

